export const isHalfWidthNumeric = (value: string): boolean => {
  return /^[0-9]+$/.test(value)
}

export const isHalfWidthAlphaNumeric = (value: string): boolean => {
  return /^[0-9a-zA-Z]+$/.test(value)
}

export const isHalfWidthAlphaNumericWithSymbols = (value: string): boolean => {
  return /^[0-9a-zA-Z@._+\-]+$/.test(value)
}

/** 全角英数字（０-９Ａ-Ｚａ-ｚ）を含む場合に true を返却 */
export const containsFullWidthAlphaNumeric = (value: string): boolean => {
  return /[\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A]/.test(value)
}

export const isValidPhoneNumber = (phone: string): boolean => {
  const regex = /^0[0-9]{1,4}-[0-9]{1,4}-[0-9]{1,4}$/
  return regex.test(phone)
}
